<template>
  <div class="md-layout md-alignment-center-center gray-6 bg">
    <div class="md-layout-item md-size-33">
      <reset-password-form />
    </div>
  </div>
</template>

<script>
import ResetPasswordForm from "../../components/auth/ResetPasswordForm";

export default {
  name: 'reset-password',
  components: {
    ResetPasswordForm
  }
};
</script>

<style>
</style>
